export const AdLeftSidebar = () => {
    return <div data-aaad="true" data-aa-adunit="/275516369/ImageResizer_LeftSidebar" className="flex items-center justify-center"></div>;
};
